export default {
  methods: {
    toCurrency(num){
      // 文字列にする
      num = String(num);
      // 返却用
      var separated = '';
      // 位置文字ずつ配列にする
      var nums = num.split('');
      // 長さを入れとく
      var len = nums.length;
      // 一文字ずつ追加してくよ
      for(var i = 0; i < len; i++){
          // 後ろから追加していく
          separated = nums[(len-1)-i] + separated;
          // 3桁ごとにカンマ追加
          if(i % 3 === 2 && len > 3){
              separated = ',' + separated;
          }
      }
      return separated;
    },
  }
}
